<div
  id="userCommentsModal"
  tabindex="-1"
  role="dialog"
  class="modal fade modal-colored-header"
>
  <div class="modal-dialog modal-lg">
    <div style="background-color: #009">
      <div class="panel-heading headering">
        <h1>{{ commentsData?.userName }}'s Comments</h1>
        <button
          #closeUserCommentsModal
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="close()"
        >
          &times;
        </button>
      </div>
    </div>

    <div class="panel-body" style="background-color: white; color: black">
      <div class="col-md-12">
        <div *ngIf="isLoading" class="text-center my-4">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading comments...
        </div>
        <div *ngIf="!isLoading">
          <a
            class="bold"
            style="font-size: 17px"
            [href]="'mailto:' + commentsData?.userEmail"
            >{{ commentsData?.userEmail }}</a
          >
          <ul class="timeline" *ngIf="!isLoading" style="margin: 0">
            <ng-container
              *ngIf="commentsData?.comments?.length; else noComments"
            >
              <li
                class="timeline-item timeline-item-detailed"
                *ngFor="let comment of commentsData.comments"
              >
                <div class="timeline-date">
                  <span>{{ comment.createdDate | date : "MMMM d, y" }}</span>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header" style="padding: 0">
                    <span class="timeline-time">{{
                      comment.createdDate | date : "shortTime"
                    }}</span>
                  </div>
                  <p class="timeline-activity" style="margin-top: 8px">
                    <ng-container [ngSwitch]="comment.commentType">
                      <span
                        *ngSwitchCase="1"
                        class="s7-note2"
                        style="margin-right: 6px"
                      ></span>
                      <span
                        *ngSwitchCase="2"
                        class="s7-like2 dislike"
                        style="margin-right: 6px"
                      ></span>
                    </ng-container>
                    {{ comment.comment }}
                  </p>
                </div>
              </li>
            </ng-container>
            <ng-template #noComments>
              <li class="timeline-item">
                <div class="timeline-content">
                  <p>No comments available for this user.</p>
                </div>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
